import React, { Component } from 'react';
import { connect } from 'react-redux';
import { verifyChangeEmail, fetchMailLists, updateMailLists, updateMailListsSuccess } from '../../actions';
import MyS4CUnAuthNav from './MyS4CUnAuthNav';
import MyS4CAuthNav from './MyS4CAuthNav';
import MyS4CAPIErrorAlert from './alerts/MyS4CAPIErrorAlert';
import translate from '../TranslateHOC';
import {EMAIL_VERIFY_ERROR} from "../../actions/types";
import CommsVerifyForm from './forms/CommsVerifyForm';
import { PATH_COMMS, MAIL_LIST_ON_SIGNUP_ID } from '../../constants';

class MyS4CVerifyEmailChange extends Component {

	constructor () {
		super();
		this.handleSignInSubmit = this.handleSignInSubmit.bind(this);
	}

	UNSAFE_componentWillMount() {
		const verifyCode = this.props.match.params.verifyCode ? this.props.match.params.verifyCode.replace(/\D/g, "").substring(0,6) : '';
		const email = this.props.match.params.email ? this.props.match.params.email : '';

		if (email && verifyCode) {
			this.props.verifyChangeEmail(email,verifyCode);
		}

		if(this.props.isAuth) {
			this.props.fetchMailLists();
		}
	}

	UNSAFE_componentWillReceiveProps = (nextProps) => {
		if(nextProps.curLang !== this.props.curLang) {
				this.props.verifyChangeEmail(this.props.match.params.email,this.props.match.params.verifyCode.replace(/\D/g, "").substring(0,6));
				if(nextProps.isAuth) { this.props.fetchMailLists();}
		}

		if(nextProps.mailListUpdateSuccess === true){
				this.props.updateMailListsSuccess();
				this.props.history.push(PATH_COMMS);
		}
	}

	handleSignInSubmit = (values) => {
		if(Object.keys(values).length > 0) {
			const mailName = Object.keys(values)[0];
			const mailValue = values[mailName];
			const mailId = mailName.split("_")[1];
			this.props.updateMailLists(mailId, mailValue===true ? 'Y' : 'N');
		}
	}

	render() {
		const { strings, errorMessage, success, isAuth, mailListData, mailListError } = this.props;
		const activeLocation = this.props.location.pathname;
		const mailList = mailListData.mailing_lists ? mailListData.mailing_lists.find(x => x.id === MAIL_LIST_ON_SIGNUP_ID).subscribed_flag : 'N';

		return (
			<div className="sign-in">
				{!isAuth && <MyS4CUnAuthNav active={activeLocation}/>}
				{ isAuth && <MyS4CAuthNav active={activeLocation} history={this.props.history}/> }
				<section className="my-s4c-content">

					<div className="sign-in__message">
						<h2 className="sign-in__message-title">{strings.verifyEmail}</h2>
						{ success &&
							<div className="my-s4c-page__body " dangerouslySetInnerHTML={{__html: strings.verifyingEmailMessage}}></div>
						}

						{ !success &&
							<div className="my-s4c-page__body">{strings.verifyingPlease}</div>
						}

						<MyS4CAPIErrorAlert	errorMessage={errorMessage} errorType={EMAIL_VERIFY_ERROR}/>

						{ isAuth && mailList && mailList === 'N' &&
							<CommsVerifyForm strings={strings} onSubmit={this.handleSignInSubmit} />
						}

						<MyS4CAPIErrorAlert errorMessage={mailListError} errorType={EMAIL_VERIFY_ERROR}/>

					</div>
					<div className="my-s4c-content__bg">
					</div>

				</section>
			</div>
		);
	}
}

function mapStateToProps(state) {
      return {
      curLang: state.curLang,
		  success: state.verifyChangeEmail.success,
		  errorMessage: state.verifyChangeEmail.error,
		  isAuth: state.auth.authenticated,
			mailListData: state.mailListData,
			mailListError: state.mailListData.error,
			mailListUpdateSuccess: state.mailListUpdate.success
      }
}

export default translate(connect (mapStateToProps,
	{ verifyChangeEmail, fetchMailLists, updateMailLists, updateMailListsSuccess })(MyS4CVerifyEmailChange));
